import { DEFAULT_LOCALE, ILanguageState } from "../model"

export function getDefaultLanguageState(): ILanguageState {
  return {
    locale: DEFAULT_LOCALE
  }
}
